import React from 'react'
import './Caroussel.css'
function Caroussel() {
  return (
    <div className='Caroussel'>
    </div>
  )
}

export default Caroussel